import React, { Component } from 'react';
import { connect } from 'react-redux';

const styles = {
    errorStyle: {
    
    }
  };


  const mapStateToProps = (state) => {
    // console.log('mapStateToProps');
    // console.log(state);    
    return {        
            application: state.application
    };
  };
  
const mapDispatchToProps = (dispatch) => {
    return {
        // companyDetails: (id) => dispatch(getFetchCompany(id)),      
 }} 

class ApplicationDetails extends Component {       

    constructor(props) {
        super(props);    
        this.state = {
        };
      }


render () {
    return (           

        <div className="applyLoanResult">
          <div className="container">
            <div className="row">
            <div className="col-12 col-md-12">
              <h1>Rahoitusta hakeva yritys</h1>
            </div>
              <div className="col-6 col-md-3">
                  Nimi
                </div>
                <div className="col-6 col-md-9">
                  {this.props.application.companyName}
                </div>
            </div> 
            <div className="row"> 
                <div className="col-6 col-md-3"></div>
                <div className="col-12 col-md-9">
                  {this.props.application.businessLine}
                </div>
            </div> 
           <div className="row">
              <div className="col-6 col-md-3">
              Y-tunnus
                </div>
                <div className="col-6 col-md-9">
                  {this.props.application.bic}
                </div>
            </div> 
            <div className="row">
              <div className="col-6 col-md-3">
              Osoite
                </div>
                <div className="col-6 col-md-9">
                  {this.props.application.address}, {this.props.application.city}
                </div>
            </div> 

          

            <div className="row"> 
            <div className="col-12 col-md-12">
                <h1>Yhteyshenkilön tiedot</h1>
                </div>
                <div className="col-6 col-md-3">
                Nimi
                </div>
                <div className="col-12 col-md-9">
                  {this.props.application.firstName} {this.props.application.lastName} ({this.props.application.ssn})
                </div>
            </div> 

            <div className="row">
              <div className="col-6 col-md-3">
              Sähköpostiosoite
                </div>
                <div className="col-6 col-md-9">
                  {this.props.application.email}
                </div>
            </div> 

                        <div className="row">
              <div className="col-6 col-md-3">
              Puhelin
                </div>
                <div className="col-6 col-md-9">
                  {this.props.application.phone}
                </div>
            </div> 
            <div className="row"> 
            <div className="col-12 col-md-12">
                <h1>Lainahakemus</h1>
                </div>
                <div className="col-6 col-md-3">
                Määrä
                </div>
                <div className="col-12 col-md-9">
                  {this.props.application.loanAmount} €
                </div>
            </div> 

            <div className="row">
              <div className="col-6 col-md-3">
              Laina-aika
                </div>
                <div className="col-6 col-md-9">
                  {this.props.application.loanLength} kuukautta
                </div>
            </div>   

          
          {/*
            <div className="row">
              <div className="col-6 col-md-3">
              Lainan tyyppi
                </div>
                <div className="col-6 col-md-9">
                  Annuiteetti tasaerä
                </div>
            </div>             
          
            <div className="row">
              <div className="col-6 col-md-3">
              Haettu kuukausierä
                </div>
                <div className="col-6 col-md-9">
                {this.props.application.monthlyPayment} euroa
                </div>
            </div>             
          */}
Voit tarkastella hakemuksen tilaa ja nostaa hyväksytyn rahoituksen <a href="https://app.kasvurahoitus.fi/login">kirjautumalla asiakasportaaliimme.</a>

          </div>
        </div>   
  
    )
 }
}

export default connect(mapStateToProps,mapDispatchToProps)(ApplicationDetails);    

    
